/**
 * Dashboard Page - Renders TodayView as the default and only dashboard view
 */
import TodayView from "@/components/dashboard/TodayView";

export default function DashboardPage() {
  return (
    <div className="min-h-screen bg-slate-50/50 -m-4 md:-m-6 p-4 md:p-6 lg:p-8" data-testid="dashboard-page">
      <div className="max-w-[1400px] mx-auto px-2 md:px-6 lg:px-10">
        <TodayView />
      </div>
    </div>
  );
}
